<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from 'cn'
import { useVModel } from '@vueuse/core'

import { textareaVariants } from './variants'

const props = defineProps<{
  class?: HTMLAttributes['class']
  defaultValue?: string | number
  modelValue?: string | number
  modelModifiers?: Record<string, true | undefined>
  lazy?: boolean
  hasError?: boolean
}>()

const emits = defineEmits<{
  'update:modelValue': [payload: string | number]
}>()

const element = useTemplateRef<HTMLTextAreaElement>('textarea')

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

const isLazy = computed(() => !!props.modelModifiers?.lazy || !!props.lazy)

const handleChange = (e: Event) => {
  if (isLazy.value)
    emits('update:modelValue', (e.target as HTMLTextAreaElement).value)
}

const handleInput = (e: Event) => {
  if (!isLazy.value)
    emits('update:modelValue', (e.target as HTMLTextAreaElement).value)
}

defineExpose({
  element,
})
</script>

<template>
  <textarea
    ref="textarea"
    :value="modelValue"
    :class="cn(textareaVariants({ hasError }), props.class)"
    @change="handleChange"
    @input="handleInput"
  />
</template>
